function initCenteredScalingNavigationBar() {
    const navigationInnerItems = document.querySelectorAll(
        '[data-navigation-item]'
    )

    // Apply CSS transition delay
    navigationInnerItems.forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.05}s`
    })

    // Toggle Navigation
    document
        .querySelectorAll('[data-navigation-toggle="toggle"]')
        .forEach((toggleBtn) => {
            toggleBtn.addEventListener('click', () => {
                const navStatusEl = document.querySelector(
                    '[data-navigation-status]'
                )
                if (!navStatusEl) return
                if (
                    navStatusEl.getAttribute('data-navigation-status') ===
                    'not-active'
                ) {
                    navStatusEl.setAttribute('data-navigation-status', 'active')
                    // If you use Lenis you can 'stop' Lenis here: Example Lenis.stop();
                } else {
                    navStatusEl.setAttribute(
                        'data-navigation-status',
                        'not-active'
                    )
                    // If you use Lenis you can 'start' Lenis here: Example Lenis.start();
                }
            })
        })

    // Close Navigation
    document
        .querySelectorAll('[data-navigation-toggle="close"]')
        .forEach((closeBtn) => {
            closeBtn.addEventListener('click', () => {
                const navStatusEl = document.querySelector(
                    '[data-navigation-status]'
                )
                if (!navStatusEl) return
                navStatusEl.setAttribute('data-navigation-status', 'not-active')
                // If you use Lenis you can 'start' Lenis here: Example Lenis.start();
            })
        })

    // Key ESC - Close Navigation
    document.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
            const navStatusEl = document.querySelector(
                '[data-navigation-status]'
            )
            if (!navStatusEl) return
            if (
                navStatusEl.getAttribute('data-navigation-status') === 'active'
            ) {
                navStatusEl.setAttribute('data-navigation-status', 'not-active')
                // If you use Lenis you can 'start' Lenis here: Example Lenis.start();
            }
        }
    })

    const navItems = document.querySelectorAll('.js-mobileNavItem')
    navItems.forEach((i) => {
        const navStatusEl = document.querySelector('[data-navigation-status]')
        i.addEventListener('click', () => {
            navStatusEl.setAttribute('data-navigation-status', 'not-active')
        })
    })
}

// Initialize Centered Scaling Navigation Bar
document.addEventListener('DOMContentLoaded', function () {
    initCenteredScalingNavigationBar()
})
